import { Component } from '@angular/core';
import { AppConfig } from '../../../config/appConfig';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})

export class HomeComponent {
  title = AppConfig.title;
  slogan = this.getRandomSlogan();

  getRandomSlogan(): string {
    const slogans = AppConfig.slogans;
    return slogans[Math.floor(Math.random() * slogans.length)];
  }

}
